import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import Site from 'stores/Site'

import Page from 'classes/Page'

export default class Campaign extends Page {
    constructor() {
        super()
    }

    init() {
        super.init()

        this.initSidebar()
        this.initContentNav()
    }

    initSidebar() {
        if (Site.isMobile) return

        const section = Site.page.querySelector('.s-campaign-content')
        const sidebar = section.querySelector('.s-sidebar')
        const sidebarInner = section.querySelector('.s-sidebar-inner')

        ScrollTrigger.create({
            trigger: sidebarInner,
            start: ()=> {
                return `top ${Site.header.offsetHeight}`
            },
            pin: true,
            end: ()=> {
                const totalHeight = sidebar.offsetHeight
                const sidebarHeight = sidebarInner.offsetHeight
                const stickHeight = totalHeight - sidebarHeight
                return `+=${stickHeight}`
            }
        })
    }

    initContentNav() {
        if (Site.isMobile) return

        const section = Site.page.querySelector('.s-campaign-content')

        this.headings = section.querySelectorAll('.s-content h2')

        if (this.headings.length === 0) return

        this.wrapper = Site.page.querySelector('.s-toc')
        this.navItems = []
        this.headingScrollers = []
        const els = this.wrapper.querySelectorAll('.s-toc-link')

        els.forEach((el, i) => {
           el.addEventListener('click', (e)=> {
               e.preventDefault()

                this.navigateHeading(i)
            })

            this.navItems.push({
                el,
            })
        })

        this.headings.forEach((el, i) => {
            this.headingScrollers[i] = ScrollTrigger.create({
                trigger: el,
                start: ()=> {
                    return `top-=${Site.header.offsetHeight} top`
                },
                onEnter: () => {
                    this.wrapper.querySelectorAll('.s-toc-link.active').forEach(item=> {
                        item.classList.remove('active')
                    })

                    this.navItems[i].el.classList.add('active')
                },
                onLeaveBack: () => {
                    if (i === 0) return

                    this.wrapper.querySelectorAll('.s-toc-link.active').forEach(item=> {
                        item.classList.remove('active')
                    })

                    this.navItems[i - 1].el.classList.add('active')
                }
            })
        })
    }

    navigateHeading(i) {
        const el = this.headings[i]
        const target = el.getBoundingClientRect().top + window.scrollY
        const scrollingDown = target > window.scrollY
        const offset = scrollingDown ? Site.header.offsetHeight - 60 : Site.header.offsetHeight - 20

        window.scrollTo({ top: target - offset, behavior: 'smooth' })
    }

    onResize() {
        super.onResize()
    }

    onScroll() {
        super.onScroll()
    }
}